import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { ShellLayout } from './components/ShellLayout';
import { AdminPage } from './pages/AdminPage';
import { AuthProgressPage } from './pages/AuthProgressPage';
import { LoginPage } from './pages/LoginPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { ProfilePage } from './pages/ProfilePage';
import { ToolsPage } from './pages/ToolsPage';
import { UsersPage } from './pages/UsersPage';
import { PlatformAccessPage } from './pages/PlatformAccessPage';
import { LogsPage } from './pages/LogsPage';
import { AccessDeniedPage } from './pages/AccessDeniedPage';
import './custom.css';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/auth/progress" element={<AuthProgressPage />} />
        <Route path="/access-denied" element={<AccessDeniedPage />} />
        <Route
          path="/platforms"
          element={
            <ProtectedRoute>
              <ShellLayout>
                <ToolsPage />
              </ShellLayout>
            </ProtectedRoute>
          }
        />
        <Route path="/tools" element={<Navigate to="/platforms" replace />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ShellLayout>
                <ProfilePage />
              </ShellLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <ShellLayout>
                <UsersPage />
              </ShellLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/platform-access"
          element={
            <ProtectedRoute>
              <ShellLayout>
                <PlatformAccessPage />
              </ShellLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <ShellLayout>
                <AdminPage />
              </ShellLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/logs"
          element={
            <ProtectedRoute>
              <ShellLayout>
                <LogsPage />
              </ShellLayout>
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/platforms" replace />} />
      </Routes>
    </AuthProvider>
  );
}
